module.exports = __webpack_public_path__ + "static/media/chevron_right.2ca35728.svg";